import { get } from 'lodash-es';
import { defaultMemoize } from 'reselect';

// import { SubscriptionsFeaturesDict } from '../../../utils/SubscriptionsDict';

export const getSubscriptionsData = defaultMemoize(state =>
  get(state, 'subscription.subscriptions.data', []),
);

const start_wiggle_room_days = 62; // How many days we should be okay witha someone not having finished their payment for new accounts being setup.

function isCurrent(subscription) {
  if (subscription.status === 'past_due') {
    let days = (subscription.start_date - new Date().getTime() / 1000) / 60 / 60 / 24;
    if (days > -start_wiggle_room_days) {
      return true;
    }
  }

  if (subscription.status === 'active' || subscription.status === 'trialing') {
    return true;
  }

  return false;
}

export const ParsedSubscriptionsData = defaultMemoize(state => {
  const subscriptions = get(state, 'Billing.subscription.subscriptions.data', []);
  let subs = [];
  subscriptions.forEach(subscription => {
    const { items, plan } = subscription;
    const isActive = isCurrent(subscription);
    const planName = (plan?.nickname || plan?.product_obj?.name || '').toLowerCase();
    if (isActive) {
      if (planName) {
        subs.push(planName);
      } else if (items?.data && items.data.length > 0) {
        items.data.forEach(item => {
          const itemName = (
            item.plan?.nickname ||
            item.plan?.product_obj?.name ||
            ''
          ).toLowerCase();
          subs.push(itemName);
        });
      }
    }
  });
  return subs;
});

export const SubscriptionsDataV2 = defaultMemoize(state => {
  return get(
    state,
    `Billing.subscriptionV2.${state.Billing.stripeDomainSlug}.subscriptions.data`,
    [],
  );
});

export const IsFetching = defaultMemoize(state =>
  get(state, 'Billing.isFetching', false),
);

export const PlaidToken = defaultMemoize(state => get(state, 'Billing.plaidToken', ''));

export const ApiErrors = defaultMemoize(state => get(state, 'Billing.ApiErrors', false));

export const PlanPreviewTotal = defaultMemoize(state => {
  let total = get(state, 'Billing.subscriptionPreview.amount_due', null);
  if (total) {
    return total / 100;
  }
});

export const Invoices = defaultMemoize(state => get(state, 'Billing.invoices', []));
export const InvoicesMulti = defaultMemoize(state =>
  get(state, 'Billing.invoicesV3', {}),
);

export const getFetchError = defaultMemoize(state => get(state, 'fetchError', null));

export const PaymentMethods = defaultMemoize(state =>
  get(state, 'Billing.methods', []).map(method => ({ ...method })),
);

export const PaymentMethodsV3 = defaultMemoize(state =>
  get(state, 'Billing.methodsV2', {}),
);

export const StripeDomainSlug = defaultMemoize(state =>
  get(state, 'Billing.stripeDomainSlug', 'paperos'),
);

export const IsPaymentMethodAvailable = defaultMemoize(
  state => get(state, 'Billing.methods', []).length > 0,
);

export const IsPaymentMethodAvailableV2 = defaultMemoize(
  (state, stripeDomainSlug) =>
    (get(state, 'Billing.methodsV2', {})[stripeDomainSlug]?.methods || []).length > 0,
);

export const PaymentMethodsWithDefault = defaultMemoize(state =>
  get(state, 'Billing.methods', []).map(method => ({
    ...method,
    is_default: method.id === state.Billing.defaultMethod,
  })),
);

export const FilteredPaymentMethodsWithDefault = defaultMemoize(state =>
  get(state, 'Billing.methods', [])
    .filter(e => e.status !== 'new' && e.status !== 'verification_failed')
    .map(method => ({
      ...method,
      is_default: method.id === state.Billing.defaultMethod,
    })),
);

export const AccountMercuryBanks = defaultMemoize(
  state => state.Billing.accountMercuryBanks,
);
